import { Component } from '@angular/core';

@Component({
  selector: 'app-section-titulo-educacao-tecnologica',
  templateUrl: './section-titulo-educacao-tecnologica.component.html',
  styleUrls: ['./section-titulo-educacao-tecnologica.component.scss'],
})
export class SectionTituloEducacaoTecnologicaComponent {}
